"use client"

import Link from "next/link"
import Image from "next/image"
import { useState } from "react"

export default function Footer() {
    const formId = process.env.NEXT_PUBLIC_EMAIL_FORM
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [formSuccess, setFormSuccess] = useState(false)
    const [formError, setFormError] = useState(false)

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        setIsSubmitting(true)

        try {
            const form = e.currentTarget
            const formData = new FormData(form)

            const response = await fetch(`https://formspree.io/f/${formId}`, {
                method: "POST",
                body: formData,
                headers: {
                    Accept: "application/json",
                },
            })

            if (!response.ok) {
                throw new Error("Form submission failed")
            }

            setFormSuccess(true)
        } catch (error) {
            setFormError(true)
            console.error("Form error:", error)
        } finally {
            setIsSubmitting(false)
        }
    }
  return (
    <div className="footer-bvf-d ff-r-cd">
      <div className="container-offer cv-top-d">
        <Link href="/" className="logo-footer-fd">
          <Image
            src="/webflow-assets/images/logo-footer-d.png"
            loading="lazy"
            width="202"
            height="50"
            alt="ListKit"
            className="logo-footer-fd"
          />
        </Link>

        <div>
          <div className="fle-dws">
            <div className="comparis">
              <div className="text-bold-f-er">Comparison</div>
              <div className="ddds-iiu">
                <Link href="/comparison-listkit-vs-apollo" className="t-l-comp link-param">
                  ListKit vs. Apollo.io
                </Link>
              </div>
              <div className="ddds-iiu">
                <Link href="/comparison-listkit-vs-zoominfo" className="t-l-comp link-param">
                  ListKit vs. Zoominfo
                </Link>
              </div>
              <div className="ddds-iiu">
                <Link href="/comparison-listkit-vs-lusha" className="t-l-comp link-param">
                  ListKit vs. Lusha
                </Link>
              </div>
              <div className="ddds-iiu">
                <Link href="/comparison-listkit-vs-clearbit" className="t-l-comp link-param">
                  ListKit vs. Clearbit
                </Link>
              </div>
              <div className="ddds-iiu">
                <Link href="/comparison-listkit-vs-cognism" className="t-l-comp link-param">
                  ListKit vs. Cognism
                </Link>
              </div>
              <div className="ddds-iiu">
                <Link href="/comparison-listkit-vs-rocketreach" className="t-l-comp link-param">
                  ListKit vs. RocketReach
                </Link>
              </div>
              <div className="ddds-iiu">
                <Link href="/comparison-listkit-vs-snov-io" className="t-l-comp link-param">
                  ListKit vs. Snov.io
                </Link>
              </div>
              <div className="ddds-iiu">
                <Link href="/comparison-listkit-vs-seamless" className="t-l-comp link-param">
                  ListKit vs. Seamless
                </Link>
              </div>
              <div className="ddds-iiu">
                <Link href="/triple-verified-leads" className="t-l-comp link-param">
                  Triple verified leads
                </Link>
              </div>
            </div>

            <div className="df-oefc">
              <div className="text-bold-f-er">Resources</div>
              <Link
                href="https://join.slack.com/t/listkitcommunity/shared_invite/zt-2zmqzn4es-9dJqVfbU8k7cR2ve_HFRcA"
                target="_blank"
                className="links-menu__link links-menu__link--gap link-param"
              >
                Community
              </Link>
              <Link href="/demo" className="links-menu__link links-menu__link--gap link-param">
                Demo
              </Link>
              <Link href="/strategy-call" className="links-menu__link links-menu__link--gap link-param">
                Book a strategy call
              </Link>
              <Link
                href="/cold-email-setup"
                className="links-menu__link links-menu__link--gap ref-controll link-home-ref link-param"
              >
                Cold email setup
              </Link>
              <Link
                href="/case-studies"
                className="links-menu__link links-menu__link--gap ref-controll link-home-ref link-param"
              >
                Case studies
              </Link>
              <Link
                href="/wall-of-love"
                className="links-menu__link links-menu__link--gap ref-controll link-home-ref link-param"
              >
                Wall of Love
              </Link>
              <Link
                href="https://docs.listkit.io/en/"
                target="_blank"
                className="links-menu__link links-menu__link--gap ref-controll link-home-ref link-param"
              >
                Help Center
              </Link>
              <Link
                href="/affiliates"
                className="links-menu__link links-menu__link--gap link-home-ref ref-controll link-param"
              >
                Affiliate program
              </Link>
              <Link
                href="/knowledge-base"
                className="links-menu__link links-menu__link--gap link-home-ref ref-controll link-param"
              >
                Knowledge base
              </Link>
              <Link
                href="/hubspot-integration"
                className="links-menu__link links-menu__link--gap link-home-ref ref-controll link-param"
              >
                HubSpot Integration
              </Link>
              <Link href="/opt-in-for-lead-magnet" className="links-menu__link links-menu__link--gap link-param">
                Opt-in for lead magnet
              </Link>
            </div>

            <div className="df-oefc">
              <div className="text-bold-f-er">Account</div>
              <Link
                href="/pricing"
                className="links-menu__link links-menu__link--gap link-home-ref ref-controll link-param"
              >
                Sign Up
              </Link>
              <Link
                href="https://app.listkit.io/login"
                target="_blank"
                className="links-menu__link links-menu__link--gap link-home-ref ref-controll link-param"
              >
                Log In
              </Link>
              <Link
                href="/terms"
                className="links-menu__link links-menu__link--gap link-home-ref ref-controll link-param"
              >
                Terms
              </Link>
              <Link
                href="/privacy"
                className="links-menu__link links-menu__link--gap link-home-ref ref-controll link-param"
              >
                Privacy Policy
              </Link>
            </div>

            <div className="df--ce-s g-r-gf">
              <div className="text-bold-f-er df-e-dc">newsletter</div>
              <div className="text-block-4">No spam, only useful information.</div>
              <div className="form-block">
                <form
                  id="email-form"
                  name="email-form"
                  className="df-e-rfc"
                  style={{ display: formSuccess ? "none" : "flex" }}
                  onSubmit={handleSubmit}
                >
                  <div className="v-d-f-ed">
                    <input
                      className="text-field w-input"
                      maxLength={256}
                      name="email"
                      placeholder="Email"
                      type="email"
                      id="email"
                      required
                      style={{ }}
                    />
                    <Image
                      src="/webflow-assets/images/cd-f-ee.svg"
                      loading="lazy"
                      alt=""
                      width={24}
                      height={24}
                      className="image-76"
                    />
                  </div>
                  <input type="submit" id="submit-button" className="submit-button" disabled={isSubmitting} style={{color: "#fff", cursor: "pointer"}} value="Subscribe" />
                </form>
                {formSuccess && (
                    <div className="success-message" id="success-message">
                    <div>Thank you! Your submission has been received!</div>
                    </div>
                )}
                 {formError && (
                    <div className="error-message" id="error-message" style={{ display: "none" }}>
                    <div>Oops! Something went wrong while submitting the form.</div>
                    </div>
                 )}
              </div>
              <div className="offer-txtf">
                Offer available for a limited time only. Secure your spot among our early adopters and enjoy a lifetime
                of exclusive benefits with ListKit.io.
              </div>
            </div>
          </div>

          <div className="copy-fde fg---de">
            2025 — ©ListKit
            <br />
            All product trademarks, names, logos, and brands are property of their respective owners
          </div>
        </div>
      </div>
    </div>
  )
}
